export default {
  home: 'ホームページ',
  aboutUs: '企業概要',
  productService: 'サービス',
  claims: 'ご請求',
  questions: 'FAQ',
  contactUs: 'お問い合わせ',
  privacyPolicy: '個人情報の取扱いについて',
  termsUse: '利用規約',
  login: 'ログイン',
  copyRight: function() { return '© ' + new Date().getFullYear() + ' Assura Asia. All Rights Reserved.'; },
  checkmore: 'もっと見る',
  slogan: ['美容医療リスク対応ソリューション', '万一の時も安心'],
  contact: 'チャットで質問する',
  back: '戻る',
  userName: 'ユーザー名',
  account: 'アカウント',
  email: 'メールアドレス',
  password: 'パスワード',
  scroll: 'SCROLL',
  backtohome: 'ホームへ戻る',
  iknowle: '了解しました',
  backtotop: 'TOP',

  // 首页
  home_aboutUs: '企業概要',
  home_aboutUs_desc: `Assura Asia は、スイス Assuraグループが2025年に設立したアジア太平洋地域向けの完全子会社です。
美容医療機関および個人のお客様に向けて、 高度なソリューションかつ適切な保障の提供に注力する、アジア太平洋地域をリードする美容医療分野に特化した革新的な保険会社です。`,
  home_productService: 'サービス',
  home_productService_desc: '私たちは、予期しないリスクを最小限に抑え、万が一の事故にも迅速かつ適切に対応できるよう、よりお客様に寄り添った保障プランを提供しています。また、アジア太平洋地域の美容医療業界の質の高い発展を支えることも、私たちの大切な使命です。',
  home_policyExchange: '交換',
  home_claims: 'ご請求',
  home_claims_desc: 'いつでも、どこでも、弊社のオンラインお問い合わせまたは専任アドバイザーを通じて、スムーズかつ迅速な保険金請求手続きをサポートいたします。',

  // 关于我们
  aboutus_aboutUs: '企業概要',
  aboutus_aboutUs_desc: `Assura Asia は、スイス Assura グループが2025年に設立したアジア太平洋地域向けの完全子会社です。
美容医療機関および個人のお客様に向けて、 高度なソリューションかつ適切な保障の提供に注力する、アジア太平洋地域をリードする美容医療分野に特化した革新的な保険会社です。

近年、美容医療技術の発展とニーズの高まりに伴い、当社の事業は急速に拡大しております。
私たちは、製品およびサービスの継続的な最適化を通じて、既存や新規のお客様に、より安全かつ充実した保障をお届けすることを目指しております。`,

  aboutus_mission: '理念・価値観',
  aboutus_mission_desc: `私たちの使命と価値観は、社外に向けた事業活動や社内の組織マネジメントに留まらず、更に広い領域にも浸透しています。
創業以来、内から外へと広がる<em>相互尊重</em>とたゆまぬ<em>卓越性の追求</em>の精神は、Assura Asia の揺るぎない基盤となっています。`,
  aboutus_mission_1_title: `お客様本位`,
  aboutus_mission_1_desc1: `"お客様の満足は、私たちの成功に他なりません。`,
  aboutus_mission_1_desc2: `いかなる状況においても、お客様の声に真摯に耳を傾け、効果的なサポートを提供することこそが、私たちのビジネスの基本方針です。`,
  aboutus_mission_2_title: `客観的な姿勢`,
  aboutus_mission_2_desc1: `どのような状況にも多面的かつ複雑な側面が存在します。`,
  aboutus_mission_2_desc2: `私たちは、ビジネスにおける機会とリスクを客観的かつ公平な視点で見極め、人間味のあるやさしさと合理性を兼ね備えた意思決定を導き出すことを目指しています。`,
  aboutus_mission_3_title: `上下一致`,
  aboutus_mission_3_desc1: `私たちは、多様な「個」の能力を尊重しあい。`,
  aboutus_mission_3_desc2: `かつ成功を収める企業はチーム全体としての調和と努力に支えられていることを深く理解しています。優秀なリーダーが構築する風通しの良い職場の中、多様な専門性を持つ人材も成長を続けるかつ平等な機会を享受できる環境を提供しています。`,
  aboutus_mission_4_title: `責任ある市民`,
  aboutus_mission_4_desc1: `私たちは、良き企業市民であることを誇りに思い。`,
  aboutus_mission_4_desc2: `企業として社会的責任を果たし、社会貢献活動の充実に取組んでいます。経営戦略を見直すことで、AAがアジア市場における新たな立ち位置を明確にしています。かつてない不確実な未来に向け、新たな挑戦と変化を続ける中でも、私たちは全力で取り組み続けていきます。`,

  aboutus_leadership: '役員紹介',
  aboutus_leadership_desc: `私たちは、経験豊富な仲間と共にさまざまな未知の挑戦に立ち向かい、
<em>社会的価値を最大限に引き出すことを目指しています</em>`,
  aboutus_leadership_1_name: ['Bharat W. Lester', 'Bharat W. Lester'],
  aboutus_leadership_1_poi: 'CEO',
  aboutus_leadership_1_desc: `Assura Asiaの最高経営責任者（CEO）として、保険業界で20年以上の豊富な経験を有する。2025年より、スイス本社にてアジア太平洋地域の事業構築と拡大に取り組み、本社入社前はスイス国立科学研究財団（SNSF）で医学美容分野の運営および管理業務を担当。それ以降、シグナ・グローバル保険やプルデンシャル保険で経営管理の分野で数多くの実績を積んできた。`,
  aboutus_leadership_2_name: ['Max Lee', 'Max Lee'],
  aboutus_leadership_2_poi: 'CRO',
  aboutus_leadership_2_desc: `Assura Asiaの最高リスク責任者（CRO）として、リスク管理、コンプライアンス、法務全般を担当。2019年当社入社、アジア太平洋および国際保険市場で15年以上の経験を有し、アクチュアリー、準備金、財務管理をはじめとする多様な分野で実績を積んできた。李氏はソウル大学を卒業し、経済学博士号を取得。`,
  aboutus_leadership_3_name: ['Cathy Ng', 'Cathy Ng'],
  aboutus_leadership_3_poi: 'CFO',
  aboutus_leadership_3_desc: `Assura Asiaの最高財務責任者（CFO）として、財務報告、計画、監督業務を担当。2015年スイス本社に入社、複数の子会社の取締役も兼任。業界で15年以上の経験を有し、グループ入社前はアーンスト・アンド・ヤング（EY）で上級管理職を務めた。吴氏はシンガポール国立大学で会計学の学士号を取得し、スタンフォード大学でMBAを修了。`,
  aboutus_leadership_4_name: ['Aaron Lim', 'Aaron Lim'],
  aboutus_leadership_4_poi: 'アジア太平洋地域業務副社長',
  aboutus_leadership_4_desc: `Assura Asiaのアジア太平洋地域業務副社長として、製品やビジネス開発業務を担当。2021年当社入社、業界で15年以上にわたる上級管理職経験。それ以前はアラガン・エステティックスアジア太平洋本社に勤務、医療美容業界における豊富な人脈とチャネルリソースを築いてきた。林氏は香港中文大学を卒業し、学士号を取得。`,
  aboutus_leadership_5_name: ['Satomi Nagano', 'Satomi Nagano'],
  aboutus_leadership_5_poi: 'アジア太平洋地域人事副社長',
  aboutus_leadership_5_desc: `Assura Asiaのアジア太平洋地域人事副社長として、事業目標達成に向けた人事戦略の推進を担当。2025年当社入社、運営、研究開発、ビジネス開発の分野で企業に重要な価値を創出し、アジア太平洋各地域の子会社において優れた候補者とビジネスパートナーの発掘・育成にも注力。長野氏は東京大学を卒業し、経営学の学位を取得。`,

  aboutus_corporate: 'サステナビリティ',
  aboutus_corporate_desc: `Assura Asia はこれまで、 
多くの患者や企業のリスク低減を通じて
業界の発展に寄与してきました。
また、社内外のパートナーと協力し、温かなこころと思いやりを持って、
<em>より良い社会の実現に向けた取り組みを進めています</em>。`,
  aboutus_corporate_1_title: `健康・寄付活動`,
  aboutus_corporate_1_desc: `さまざまな慈善団体やチームと長期的なパートナーシップを築き、社会に前向きな変化と持続可能な進歩をもたらすことに努めています。`,
  aboutus_corporate_2_title: `社会貢献活動`,
  aboutus_corporate_2_desc: `教育、環境保護、医療福祉、ボランティア活動への支援を通じて、地域社会全体の福祉向上に貢献しています。`,
  aboutus_corporate_3_title: `環境への取り組み`,
  aboutus_corporate_3_desc: `環境負荷の軽減に向けて、汚染物質の削減や資源の有効活用、持続可能な発展の実現、さらにはグリーンエネルギープロジェクトの推進に取り組んでいます。`,

  aboutus_joinus: `採用情報`,
  aboutus_joinus_title: `採用
  情報`,
  mobile_aboutus_joinus_title: `採用情報`,
  aboutus_joinus_intro1: `Assura Asia の事業は、アジア太平洋地域においてシンガポール、中国香港、インドネシア、マレーシア、タイ、韓国、日本へと広がりを見せており、今後もさらなる国や地域への展開を計画しています。その実現には、企業の持続的な成長を支える優秀な人材の存在が欠かせないと考えています。

私たちは、多様な採用手法を活用し、長期的な視点で企業の成長を共に支えていただける優秀な人材を募集しています。これまでの職務経験や経歴に加え、コミュニケーション能力、文章力、そしてチームワーク力を持つ方を求めています。`,
  aboutus_joinus_intro2: `* Assura Asia は機会の均等を重視しています。当社では、人種、肌の色、宗教、性別、妊娠、国籍、年齢、婚姻状況、性的指向、性自認、障害の有無、健康状態、退役軍人の身分など、法的に保護されたあらゆる属性に基づく差別を行いません。また、関連する法律を遵守し、障がい者に対しては合理的な配慮を提供します。(必要に応じて)。
  
  <span class="bold ffen">第三者プラットフォームに掲載されている求人情報やオープンポジションにご興味をお持ちの場合は、詳細な履歴書を添付してご応募ください</span>
<span class="link ffen">career@assuraasia.com</span>`,

  // 产品与服务
  productservice_productService: `製品・サービス`,
  productservice_productService_desc: `美容医療施術は、外見や体型を改善するための非常に効果的な方法ですが、肌への負担や傷が避けられないため、美容や体型の向上を実現する一方で、思わぬリスクやトラブルが伴うこともあります。

私たちは、このようなリスクを最小限に抑え、万が一の事故にも迅速かつ適切に対応できるよう、よりお客様に寄り添った保障プランを提供しています。また、アジア太平洋地域の美容医療業界の質の高い発展を支えることも、私たちの大切な使命です。`,

  productservice_coveragePlans: `保障プラン`,
  productservice_coveragePlans_person: `術前のリスク補償責任保険`,
  productservice_coveragePlans_person_desc: `卓越した保険プランと市場動向に対する深い理解、豊富な臨床経験を活かし、予測できないリスクが発生した場合でも、確実にサポートを提供いたします。`,
  productservice_coveragePlans_unit: `医療施設賠償責任保険`,
  productservice_coveragePlans_unit_desc: `革新的なサービスと製品を通じて、医療機関と患者様のコミュニケーションを一層円滑にし、双方の満足度を向上させるとともに、予期しない事態による医療機関の信用や経済的影響を最小限に抑えることを目指しています。`,

  productservice_partners: `パートナー企業`,
  productservice_partners_axa: `AXA`,
  productservice_partners_nissay: `NISSAY`,
  productservice_partners_hsbc: `HSBC`,
  productservice_partners_sl: `Singlife `,
  productservice_partners_aia: `AIA`,

  // 索偿
  claims_claims: `ご請求`,
  claims_claims_desc: `いつでも、どこでも、弊社のオンラインお問い合わせまたは専任アドバイザーを通じて、スムーズかつ迅速な保険金請求手続きをサポートいたします。

お客様の申請を最優先で対応し、心よりお見舞い申し上げるとともに、丁寧なサポートをお届けいたします。`,

  claims_application_inquiry: `保険金の申請・照会`,
  claims_application_inquiry_desc: `お客様の権利を守るため、迅速に保険金請求を行い、進捗状況もいつでも確認できるオンラインセルフサービスを提供しています。また、専任アドバイザーによるサポートもご利用いただけます。`,
  claims_application_inquiry_method1_title: `オンラインセルフサービス`,
  claims_application_inquiry_method1_desc: `いつでもどこでも、保険金請求の受付、手続きの進捗状況を簡単に確認いただけます。`,
  claims_application_inquiry_method2_title: `専任アドバイザーサービス`,
  claims_application_inquiry_method2_desc: `オンラインお問い合わせプラットフォームを通じて、すぐにカスタマーサービスにご相談いただけます。`,
  claims_application_inquiry_login: 'ログインして利用する',

  // 常见问题
  faq_faqs: 'FAQ',
  faq_faqs_desc: `美容医療保険に関する疑問やお手続きについて、わかりやすくご案内し、保険内容やサービスの詳細を丁寧にご説明いたします。

想さらに詳しい情報をご希望の場合は、オンラインお問い合わせフォームよりお気軽にご連絡ください。`,
  faplist: [
    {
      question: `美容医療とは？施術の種類は？`,
      ans: `美容医療とは、手術や薬剤、医療機器、さらには侵襲性、非侵襲性の医療技術を用いて、人体の外見や各部位の形状を美しく改善・修復・再生する治療法を指します。

医療的観点から、美容医療は大きく分けて 侵襲的美容施術（整形手術）と 非侵襲的美容施術（プチ整形）の2種類に分類されます。侵襲的美容施術には、皮膚の切開を伴う豊胸手術、脂肪吸引、隆鼻術、二重整形・目元整形手術などがあります。非侵襲的美容施術には、レーザー治療、高周波（RF）リフトアップ、美容注射などがあります。`},
    {
      question: `美容医療手術を受ける前に、どのような準備が必要ですか？`,
      ans: `美容医療の手術を検討されている方は、事前に以下の準備やステップを整えることで、安心して施術に臨むことができます。

1. カウンセリングを十分に受ける
自分の体調や美容に関する悩みを整理し、信頼できる医療機関で手術内容やリスクについて詳しく説明を受けた上で、納得して判断することが大切です。

2. 心の準備を整える
手術によって容貌や生活に変化が生じる可能性を理解し、その影響を前向きに受け入れる心構えを持つことが大切です。

3. 信頼できる医療機関を選ぶ
医師の経験や実績、医療機関の評判、サービス内容、費用などを総合的に比較検討し、自分に合った安心できる医療機関を見極めましょう。

4. 手術日程の計画
術後の回復時間も考慮し、十分な余裕を持ったスケジュールを立てることが大切です。妊娠中や授乳期間、月経周期などを避け、体調が整った最適なタイミングで手術を受けられるよう計画しましょう。

5. 術前検査の徹底
高血圧や心疾患、血液凝固異常などを事前に確認するための検査をしっかり受け、手術中や術後のリスクをできる限り減らしましょう。

6. 契約内容の確認
手術契約書を締結する際には、手術の内容や保証条件をしっかり確認し、不安なく手術に臨めるよう準備を整えましょう。

7. 保険への加入
美容医療に伴う予期しないトラブルに備えるため、保険に加入することで、予想外の費用負担や精神的なストレスを軽減し、安心して治療に臨むことができます。`,
    },
    {
      question: `アンダーライティング(引受審査)とは何ですか？主な流れはどのようなものですか？`,
      ans: `保険の引受にあたり、、保険会社はまず自社の引受リスクを計算します。このリスク評価の過程を「アンダーライティング（引受審査）」と言います。

一般的に、保険会社は契約者の健康状態に関する情報（過去の病歴や健康診断結果など）を収集し、その情報をもとにリスク評価を実施します。その後、リスクに応じて引受可否や保障内容が決定されます。`,
    },
    {
      question: `「FastPass」または「迅速な引受審査」とは、どのようなものですか？`,
      ans: `特定の国や地域では、当社はビッグデータの分析と経験に基づき、簡略化された引受審査の手続きを導入しており、これにより契約手続きの時間を大幅に短縮できます。

契約者は申し込み時に、システムまたは公式アンケートに従い、年齢、性別、居住地などの簡単な個人情報と、過去の病歴などの健康に関する質問に答えるだけで、最短5分で申し込みが完了し、特定の健康証明書の提出は不要です。

オンラインでの申し込みは、最高誠実義務に則り、手続きが自動化されているため、通常の手続きよりも迅速に保険契約の承認が確認できます。`,
    },
  
    {
      question: `なぜ保険加入時に健康アンケートへの記入が求められるのか？`,
      ans: `当社はお客様の健康状態をもとに、予想される死亡率や障害率、その他の保険事故の発生リスクを評価し、保険の引受可否や条件を決定いたします。お客様の健康情報は、主に健康アンケートを通じて収集されます。そのため、保険加入時には、健康アンケートを正確にご記入いただき、各項目について適切にご申告いただく必要があります。`,
    },
    {
      question: `最高誠実義務とは？`,
      ans: `最高誠実義務とは、保険契約者が申し込み時に自身の個人情報や健康状態を正確かつ誠実に開示していることを前提に、保険会社がその情報を信頼することを意味します。
もし後日、契約者が重要な情報を故意に隠したり、開示しなかったことが判明した場合、保険会社はその請求を拒否する権利を有し、場合によっては契約を解除することがあります`,
    },
    {
      question: `なぜ引受審査に通らないのか？`,
      ans: `保険会社は、引受審査の結果、契約者に対する保障リスクが当社の許容範囲を超えていると判断した場合、引受をお断りする可能性があります。`,
    },
    {
      question: `保険金請求の進捗や履歴は、どのように確認したらよいでしょうか？`,
      ans: `当サイトの個人顧客アカウントにログイン後、メニューから『請求記録』を選択し、進捗状況と履歴を確認できます。また、専任アドバイザーに直接お問い合わせいただくか、当社カスタマーサービスまでお電話ください。`,
    },
    {
      question: `保険金はどのように受け取りますか？`,
      ans: `保険金は、請求書に記載されたお支払い方法に基づきお支払いいたします。もしお支払い方法が未指定、または指定された方法が利用できない場合は、登録された口座情報に基づきお支払いさせていただきます。`,
    },
    {
      question: `保険金請求の対象となるのは、どのような加入者ですか？`,
      ans: `通常、保険金請求は契約者または被保険者がが行うことができます。ただし、「死亡保険金請求」は受取人が行うことができます。`,
    },
    {
      question: `保険金請求の処理にはどのくらいの時間がかかりますか？`,
      ans: `必要書類を受け取り次第、通常5～10営業日以内に、損害賠償の結果または進捗状況をご案内いたします。すべての保険金請求について迅速に対応するよう努めておりますが、実際の処理にかかる時間は、請求内容や事例の複雑さ、提出された書類の完全性などにより異なる場合があります。`,
    },
    {
      question: `術後の損傷や期待される効果の違いについて、どのように定義されますか？`,
      ans: `専任アドバイザーまたは提携医療機関にお問い合わせいただくことで、関連する保険契約内容をご確認いただけます。また、個人のお客様向けマイページにログインし、保険契約ページで詳細をご確認いただくことも可能です。`,
    },
    {
      question: `保険契約の内容についてどのように確認したらよいでしょうか？`,
      ans: `保険契約が成立した後、個人のお客様向けマイページにログインし、保険契約ページから詳細をご確認いただけます。`,
    }
  ],

  // 联系我们
  contactus_contactUs: 'お問い合わせ',
  contactus_contactUs_desc: `ご質問や疑問があれば、遠慮なくご相談ください。
速やかに対応いたします。`,
  contactus_inquiryType: `お問い合わせ内容`,
  contactus_inquiryType1: `お問い合わせ種別`,
  contactus_inquiryType1Options: [
    '施術リスク賠償責任保険のお問い合わせ',
    '医療施設賠償責任保険のお問い合わせ',
    '専属サポートへ問い合わせ',
    '保険特典の交換',
    '業務提携',
    'メディア関係',
    'ご意見・ご要望',
    'その他'
  ],
  contactus_countryOptions: [
    'シンガポール',
    '日本',
    '韓国',
    'マレーシア',
    'タイ',
    '中国本土',
    '中国香港',
    '中国マカオ',
    'その他の地域',
  ],
  contactus_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
  ],
  reset_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
    'その他',
  ],
  contactus_inquiryType2: `お問い合わせの内容をご入力ください`,
  contactus_contactInformation: `基本情報`,
  contactus_contactInformation1: `名`,
  contactus_contactInformation2: `姓`,
  contactus_contactInformation3: `男性`,
  contactus_contactInformation4: `女性`,
  contactus_contactInformation5: `国`,
  contactus_contactInformation6: `都市`,
  contactus_contactInformation7: `国際電話国番号`,
  contactus_contactInformation8: `携帯番号をご入力ください`,
  contactus_submit_protocol: `下記のボタンをクリックすると、当社の<a class="ffen" href="/protocol/private">『プライバシーポリシー』</a>および<a class="ffen" href="/protocol/term">『利用規約』</a>に同意したものとみなされます。`,
  contactus_submit: `送信`,
  result_feedback: `メッセージをありがとうございます。
内容を確認のうえ、できるだけ早くご連絡いたします。`,
  error_required_cannot_empty: '必須項目を空欄のままにすることはできません',

  contactus_offices: 'アジア太平洋地域事務所',
  contactus_offices_list: [
    { 
      name: 'シンガポール', 
      address: `マリーナベイ・ファイナンシャルセンター・タワー2、39階`, 
      contact: '+65 6565 7722', 
      email: 'sg@assuraasia.com' 
    },
    { 
      name: '日本国', 
      address: `東京都千代田区丸の内 1-8-3 丸の内トラストタワー本館 20階`, 
      contact: '+83 03 5288 6288', 
      email: 'jp@assuraasia.com' 
    },
    { 
      name: '韓国', 
      address: `ソウルファイナンスセンター 21階`, 
      contact: '+82 2 3888 6789', 
      email: 'kr@assuraasia.com' 
    },
    { 
      name: '中国 香港', 
      address: `香港 セントラルプラザ 35階`, 
      contact: '+852 6567 6688', 
      email: 'hk@assuraasia.com' 
    },
  ],

  // 保障计划
  plan_person: `施術リスク賠償責任保険`,
  plan_person_desc: `卓越した保険プランと市場動向に対する深い理解、豊富な臨床経験を活かし、予測できないリスクが発生した場合でも、確実にサポートを提供いたします。`,
  plan_unit: `医療施設賠償責任保険`,
  plan_unit_desc: `革新的なサービスと製品を通じて、医療機関と患者様のコミュニケーションを一層円滑にし、双方の満足度を向上させるとともに、予期しない事態による医療機関の信用や経済的影響を最小限に抑えることを目指しています.`,
  plan_btn_applynow: `今すぐ申し込む`,
  plan_btn_manual: `商品パンフレット`,
  
  plan_coverage: `保障内容`,
  plan_coverage_1: `骨格矯正・子顔矯正`,
  plan_coverage_2: `鼻整形`,
  plan_coverage_3: `目元整形`,
  plan_coverage_4: `バストの施術`,
  plan_coverage_5: `脂肪管理`,
  
  plan_person_coverage_list_1_title: `リスクによる死亡保障`,
  plan_person_coverage_list_1_desc: `美容医療行為に伴う予測不能のリスクによる死亡保障を提供し、遺族への経済的ご負担を軽減します。`,
  plan_person_coverage_list_2_title: `機能的な損傷保障`,
  plan_person_coverage_list_2_desc: `美容医療行為に起因する身体機能の損傷や喪失に対して適切な補償を提供し、お客様が安心して治療を受けられるよう万全のサポート体制を整えています。`,
  plan_person_coverage_list_3_title: `施術中の事故による損害`,
  plan_person_coverage_list_3_desc: `手術中における予期せぬ事態（医療ミスや機器の不具合による傷害など）に対して補償を提供し、お客様の正当な権利をしっかりとお守りします。`,
  plan_person_coverage_list_4_title: `満足度評価`,
  plan_person_coverage_list_4_desc: `お客様の満足度を定期的に把握し、サービス品質の向上に努めています。寄せられたご意見をもとに迅速な対応と改善を行い、より安心で質の高い美容医療サービスを提供できるよう取り組んでいます。`,

  plan_unit_coverage_list_1_title: `美容医療賠償責任補償`,
  plan_unit_coverage_list_1_desc: `美容医療施術・治療に起因する患者の死亡による損害を補償し、遺族支援やクレーム対応なども含め、医療機関への影響を最小限に抑えるようサポート致します。`,
  plan_unit_coverage_list_2_title: `機能的な損傷保障`,
  plan_unit_coverage_list_2_desc: `美容医療行為における過失により患者様へ身体機能障害を与えた場合の損害賠償を補償し、医療機関の経済的負担を軽減するとともに、患者様の権利もしっかりと守ります。`,
  plan_unit_coverage_list_3_title: `施術中の事故による損害`,
  plan_unit_coverage_list_3_desc: `施術時事故によるクレームや仕上り不良による苦情に対して具体的な損害賠償条項と基準に基づき賠償を行い、より安心で質の高い美容医療サービスを提供できるよう取り組んでいます。`,
  plan_unit_coverage_list_4_title: `満足度評価`,
  plan_unit_coverage_list_4_desc: `施術時事故によるクレームや仕上り不良による苦情に対して具体的な損害賠償条項と基準に基づき賠償を行い、より安心で質の高い美容医療サービスを提供できるよう取り組んでいます。`,

  plan_features: `プランの特徴`,
  plan_person_features_1_title: `FastPass ™`,
  plan_person_features_1_desc: `オンラインで申込可能、
  迅速な審査でスムーズにご利用いただけます。`,
  plan_person_features_2_title: `専任アドバイザー`,
  plan_person_features_2_desc: `専任アドバイザーによる個別相談、
適切なプランをご提案致します。`,
  plan_person_features_3_title: `オーダーメイドプラン`,
  plan_person_features_3_desc: `保障内容を柔軟に選択可能、
お客様のニーズに合わせたプランを提供致します。`,
  plan_person_features_4_title: `海外医療コンシェルジュサービス`,
  plan_person_features_4_desc: `アジア太平洋地域の医療リソースを活用し、
  必要なサポートをいつでもご提供いたします。`,

  plan_unit_features_1_title: `FASTPAY™️`,
  plan_unit_features_1_desc: `オンラインで申込可能、
迅速な保険金をお支払いする体制。`,
  plan_unit_features_2_title: `総合信頼性の向上`,
  plan_unit_features_2_desc: `患者さまの信頼感を高め、
医療機関の多様なサービス提供能力の向上に努めます。`,
  plan_unit_features_3_title: `事業リスクの移転`,
  plan_unit_features_3_desc: `予期せぬ事態に効果的に対応し、
経営負担の軽減を図ります。`,
  plan_unit_features_4_title: `専任サポートチーム`,
  plan_unit_features_4_desc: `専門的なサポートを提供し、
リスク事故発生時に迅速かつ円滑に対応致します。`,

  plan_moreinfo: `さらに詳しく知りたい`,
  plan_moreinfo_desc: `オンラインお問い合わせフォームよりすぐご連絡いただけます`,
  plan_moreinfo_slogan: `美容医療リスク対応ソリューション、
万一の時も安心`,
  plan_moreinfo_nores: `免責事項`,
  plan_moreinfo_nores_desc: `Assura Asiaおよびその関連会社、関連企業、子会社は、特定の目的や製品の表示、推奨を含むすべての明示的および暗黙的な保証を否認します。利用者は、提供された意見、助言、サービス、その他の情報の正確性、完全性、有用性を評価する責任があります。また、ご自身の状況に応じて、法律や医療などの専門家に相談してください。Assura Asiaおよびその関連会社、関連企業、子会社は、本ウェブサイトまたは表示された資料の使用に起因する直接的、間接的、特別、偶発的、必然的な損害について責任を負いません。`,

  // 登录
  login_loginType: `ログインタイプを選択してください`,
  login_loginType_desc: `保障プランや関連業務の最新情報をアクセスして確認いただけます`,
  login_loginType_1_title: '個人のお客さま',
  login_loginType_1_desc: '術前のリスク補償責任保険',
  login_loginType_2_title: '法人のお客さま',
  login_loginType_2_desc: '医療施設賠償責任保険',
  login_loginType_3_title: '代理店および保険仲介人',
  login_loginType_3_desc: '業務管理',
  login_forget_password_tip: `パスワードを忘れた場合？`,
  login_forget_password_find: `<span class="ffen">はこちらをクリックして回復</span>`,
  login_noaccount_tip: `アカウントをお持ちでないですか？`,
  login_regsiter_now: '今すぐ登録',
  login_error_account: 'ユーザー名またはメールアドレスが間違っています。もう一度お試しください',
  login_error_password: 'パスワードが間違っています。もう一度お試しください',

  // 兑换
  exchange_title: '特典を引き換え',
  exchange_welcome_txt: 'おかえりなさい，Oli',
  exchange_loginType_1_title: 'カードコード情報',
  exchange_loginType_1_plsholder: '引き換えコード',
  exchange_loginType_1_error: 'キーが間違っています。もう一度お試しください',
  exchange_description_title: '引き換えの説明',
  exchange_description_txt: ` · 交換カードは連携後、解除や他アカウントでの使用はできません。
 · マイページで保険を交換してください。
 · ご不明点はサポートまたは担当者へ。`,
  exchange_btn: '特典を引き換え',

  // 注册
  register_title: 'アカウント',
  register_account: 'ユーザー名',
  register_account_tip: '3-20文字（英数・_）',
  register_account_exist: '账号已存在，请重试',
  register_email:'メール',
  register_email_tip: 'メール形式を確認',
  register_email_exist: '邮箱已存在，请重试',
  register_password: 'パスワード設定',
  register_password_tip: '7文字以上（大文字・小文字・数字）',
  register_password_tip_mobile:`7文字以上（大文字・小文字・数字）`,
  register_password_again: 'パスワード設定',
  register_password_again_error: 'パスワード不一致',
  register_promo_code:'招待コード',
  register_promo_code_error:'招待コードエラー',
  next: '次へ',
  register_cancel_btn: 'キャンセル',
  placeholder_common: '入力',

    //找回密码
    reset_password_title: 'パスワード再設定',
    reset_password_subtitle: 'メールまたは携帯で再設定',
    reset_password_menu: '方法を選択:',
    reset_password_email: '登録メールを入力',
    reset_password_mobile:'登録電話番号を入力',
    reset_no_account: '未登録アカウント',

    //cookie
  cookie_accept_title: 'Cookie 設定',
  cookie_accept_context: '「受け入れる」をクリックすると、ウェブサイトのナビゲーションを向上させ、サイトの使用状況を分析し、マーケティング活動を支援するために、お使いのデバイスに Cookie を保存することに同意したことになります。',
  cookie_accept_btn: '受け入れる',
  cookie_reject_btn: '拒否する'
}



